export default __webpack_public_path__ + "static/media/konczer-facebook.1c868402.png";